import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { useContractorTimesheetAccess } from '../../hooks/useContractorTimesheetAccess';

type Props = {
  /** Primary nav tab vs. compact user-menu row */
  variant?: 'nav' | 'menu';
  onNavigate?: () => void;
};

const ContractorTimesheetsHeaderLink: React.FC<Props> = ({ variant = 'nav', onNavigate }) => {
  const { canAccess } = useContractorTimesheetAccess();
  const location = useLocation();

  if (!canAccess) return null;

  const active = location.pathname.startsWith('/contractor-timesheets');

  if (variant === 'menu') {
    return (
      <Link
        to="/contractor-timesheets"
        className="dropdown-item"
        onClick={onNavigate}
      >
        <Clock size={16} />
        My Hours
      </Link>
    );
  }

  return (
    <Link
      to="/contractor-timesheets"
      className={`nav-item ${active ? 'active' : ''}`}
    >
      My Hours
    </Link>
  );
};

export default ContractorTimesheetsHeaderLink;
